import React, { useEffect } from "react";
import Industries from "../components/sections/Industries";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../hooks/useSEO";
import { useLang } from "../context/LanguageContext";

export default function IndustriesPage() {
  const { lang } = useLang();
  useSEO({
    title: lang === "pl" ? "Branże — LK LOG" : "Industries — LK LOG",
    description:
      lang === "pl"
        ? "Obsługujemy automotive, przemysł ciężki, rolnictwo, spożywczy, FMCG, meble, import z Azji i branżę opakowań."
        : "We serve automotive, heavy industry, agriculture, food, FMCG, furniture, Asia imports and packaging.",
    path: "/branze",
    lang,
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <main data-testid="industries-page" className="pt-20">
      <Industries />
      <FinalCTA />
    </main>
  );
}
